// src/Components/Ui/ToastHost.tsx
// The one toast slot: top-right, under the shell HUD (pass/toasts.scss reads
// --shell-top so nothing ever renders beneath the header).
import React from "react";
import { useToast } from "../../Context/ToastContext";
import Icon, { IconName } from "./Icon";

const ICON: Record<string, IconName> = {
  info: "info",
  success: "check",
  error: "info",
};

const ToastHost: React.FC = () => {
  const { toasts, dismiss } = useToast();
  if (toasts.length === 0) return null;

  return (
    <div className="toast-host" aria-live="polite" aria-atomic="false">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`toast toast--${t.kind}`}
          role={t.kind === "error" ? "alert" : "status"}
        >
          <span className="toast__icon" aria-hidden="true">
            <Icon name={ICON[t.kind] || "info"} size={16} />
          </span>
          <div className="toast__text">
            <div className="toast__title">{t.title}</div>
            {t.body && <div className="toast__body">{t.body}</div>}
          </div>
          <button
            type="button"
            className="toast__close"
            onClick={() => dismiss(t.id)}
            aria-label="Dismiss message"
          >
            <Icon name="close" size={18} />
          </button>
        </div>
      ))}
    </div>
  );
};

export default ToastHost;
